(() => {
  const root = document.querySelector('.ihnpc');
  if (root && !root.classList.contains('ihn-pdp-upgrade')) {
    root.querySelectorAll('details').forEach((item) => {
      item.open = true;
      item.querySelector('summary')?.addEventListener('click', (event) => event.preventDefault());
    });
  }
  document.querySelectorAll('.ihn-header__desktop-nav a').forEach((link) => {
    if (link.pathname === window.location.pathname) link.setAttribute('aria-current', 'page');
  });
  const booking = document.querySelector('[data-ihn-showroom-booking]');
  if (!booking) return;
  const thankYou = booking.dataset.thankYou;
  const variant = booking.querySelector('input[name="id"]')?.value;
  let redirected = false;
  window.addEventListener('message', (event) => {
    if (redirected || !thankYou || event.data?.type !== 'booking-successful') return;
    const iframe = document.getElementById('futureblink-embed');
    const modal = document.getElementById('futureblink-booking-modal');
    if (!iframe || event.source !== iframe.contentWindow) return;
    let origin;
    try { origin = new URL(iframe.src).origin; } catch { return; }
    if (event.origin !== origin) return;
    const nonce = new URL(iframe.src).searchParams.get('nonce');
    if (!nonce || nonce !== event.data.nonce || modal?.dataset.nonce !== nonce) return;
    if (event.data.accept_payment === true || event.data.draftOrderCheckoutUrl) return;
    if (!variant || String(event.data.variantId) !== variant) return;
    redirected = true;
    window.location.replace(thankYou);
  });
})();

